var buildQueryParamUrlPart = function (query, param, generateParamKey) {
    if (!Object.prototype.hasOwnProperty.call(query, param)) {
        return null;
    }
    var paramValue = query[param];
    if (typeof paramValue !== 'boolean' && !paramValue) {
        return null;
    }
    if (Array.isArray(paramValue)) {
        var arrayParam_1 = [];
        paramValue.forEach(function (item) {
            arrayParam_1.push(param + "[]=" + item);
        });
        return arrayParam_1.join('&');
    }
    var paramKey = generateParamKey ? generateParamKey(param) : param;
    return paramKey + "=" + paramValue;
};
export var buildURI = function (path, params) {
    if (params === void 0) { params = {}; }
    var pathParams = params.pathParams, query = params.query, filterQuery = params.filterQuery;
    var queryParams = [];
    if (pathParams) {
        Object.entries(pathParams).forEach(function (_a) {
            var name = _a[0], value = _a[1];
            if (value === undefined) {
                path = path.replace(new RegExp("/:" + name + "\\??"), '');
                return;
            }
            path = path.replace(new RegExp(":" + name + "\\??"), String(value));
        });
    }
    if (query) {
        Object.keys(query).forEach(function (param) {
            var queryParamUrlPart = buildQueryParamUrlPart(query, param);
            if (!queryParamUrlPart) {
                return;
            }
            queryParams.push(queryParamUrlPart);
        });
    }
    if (filterQuery) {
        Object.keys(filterQuery).forEach(function (param) {
            var queryParamUrlPart = buildQueryParamUrlPart(filterQuery, param, function (p) { return "filter[" + p + "]"; });
            if (!queryParamUrlPart) {
                return;
            }
            queryParams.push(queryParamUrlPart);
        });
    }
    if (queryParams.length) {
        path += "?" + queryParams.join('&');
    }
    return path;
};
